export default __webpack_public_path__ + "958c6eacb90a014aeafbe001a507988a.png";